(function () {
  if (window.__rhodePdp) return;
  window.__rhodePdp = true;
  document.addEventListener('click', function (e) {
    var scrollBtn = e.target.closest('[data-rpdp-scroll]');
    if (scrollBtn) {
      var root = scrollBtn.closest('[data-rpdp]');
      var track = root && root.querySelector('[data-rpdp-track]');
      if (track) track.scrollBy({ left: track.clientWidth * 0.8 * Number(scrollBtn.getAttribute('data-rpdp-scroll')), behavior: 'smooth' });
      return;
    }
    var tab = e.target.closest('[data-rpdp-tab]');
    if (tab) {
      var group = tab.closest('[data-rpdp]');
      var key = tab.getAttribute('data-rpdp-tab');
      group.querySelectorAll('[data-rpdp-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b === tab)); });
      group.querySelectorAll('[data-rpdp-panel]').forEach(function (p) {
        var on = p.getAttribute('data-rpdp-panel') === key;
        p.classList.toggle('is-active', on);
        p.classList.toggle('is-dim', !on);
      });
    }
  });
})();
